module.exports = __webpack_public_path__ + "img/welcome_head_icon.c3a0fb1d.png";